import axios from 'axios';

export const exportVersion = (versionId: string) =>
    axios
        .post(`configurator/version/export/${versionId}`)
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
